import "./App.scss";
import Router from "./router";
import { useEffect } from "react";
import _ from "lodash";
import { sendChatReady } from "./utils/event";
import { TopicType } from "./constant/enums";
import { useDispatch } from "react-redux";
import i18n from "./i18n";
import "moment/locale/vi";
import * as Moment from "moment";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const onLanguageChanged = (lng) => {
      Moment.locale(lng);
    };

    i18n.on("languageChanged", onLanguageChanged);

    return () => {
      i18n.off("languageChanged", onLanguageChanged);
    };
  }, []);

  useEffect(() => {
    sendChatReady();

    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const topic = _.get(data, "topic");
        const accessToken = _.get(data, "accessToken");
        const language = _.get(data, "language", "en");
        const timeZone = _.get(data, "timeZone");

        if (topic === TopicType.SET_CHAT_TOKEN && accessToken) {
          sessionStorage.setItem("accessToken", accessToken);
          i18n.changeLanguage(language);
          sessionStorage.setItem("language", language);
          sessionStorage.setItem("timeZone", timeZone);
        }
      } catch (err) {
        console.error("Invalid message format:", event.data);
      }
    };

    const handleBeforeUnload = () => {
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("me");
    };

    window.addEventListener("message", handleMessage);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("message", handleMessage);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch]);

  return (
    <>
      <Router />
    </>
  );
}

export default App;
